import React, { useCallback, useEffect, useState } from "react";
import { Table, Pagination, message } from "antd";

/**
 * Bảng phân trang dùng chung cho các tab ở trang chi tiết user.
 *
 * Mỗi tab chỉ khác nhau ở `fetcher` + `columns` nên gom vào đây thay vì viết 4 bảng
 * gần y hệt (xem user-detail-tabs-config.js).
 *
 * Props:
 *   fetcher  - async ({ page, limit }) => { rows, total }
 *   columns  - antd columns
 *   rowKey   - key của dòng (mặc định "key")
 *   pageSize - số dòng / trang (mặc định 20)
 *   reloadKey- đổi giá trị này để buộc tải lại (ví dụ sau khi đổi email)
 */
function UserDetailTable({ fetcher, columns, rowKey = "key", pageSize = 20, reloadKey }) {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const res = await fetcher({ page, limit: pageSize });
            setRows(res.rows || []);
            setTotal(res.total || 0);
        } catch {
            message.error("Không tải được dữ liệu");
            setRows([]);
            setTotal(0);
        } finally {
            setLoading(false);
        }
    }, [fetcher, page, pageSize]);

    useEffect(() => {
        load();
    }, [load, reloadKey]);

    return (
        <div className="flex flex-col gap-3">
            <Table
                columns={columns}
                dataSource={rows}
                rowKey={rowKey}
                loading={loading}
                pagination={false}
                size="small"
                scroll={{ x: "max-content" }}
            />
            {total > pageSize && (
                <Pagination
                    className="self-end"
                    current={page}
                    total={total}
                    pageSize={pageSize}
                    showSizeChanger={false}
                    onChange={setPage}
                    showTotal={(t) => `${t.toLocaleString("vi-VN")} dòng`}
                />
            )}
        </div>
    );
}

export default UserDetailTable;
